/**
 * 时间戳转换为标准时间格式
 * parms:timestamp
 */

export function timestampToTime(timestamp) {
  if (timestamp > 0) {
    let d = 1000
    if (timestamp > 100000000000) {
      d = 1
    }
    var date = new Date(timestamp * d) //时间戳为10位需*1000，时间戳为13位的话不需乘1000
    var Y = (date.getFullYear() % 2000) + '-'
    var M = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1) + '-'
    var D = (date.getDate() < 10 ? '0' + date.getDate() : date.getDate()) + ' '
    var h = (date.getHours() < 10 ? '0' + date.getHours() : date.getHours()) + ':'
    var m = date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes()
    // var s = date.getSeconds() < 10 ? '0' + date.getSeconds() : date.getSeconds()
    return Y + M + D + h + m
  } else {
    return '暂无'
  }
}

export function timestampToMonth(timestamp) {
  if (timestamp > 0) {
    let d = 1000
    if (timestamp > 100000000000) {
      d = 1
    }
    var date = new Date(timestamp * d) //时间戳为10位需*1000，时间戳为13位的话不需乘1000
    var Y = date.getFullYear() + '-'
    var M = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1) + '-'
    return Y + M
  } else {
    return '暂无'
  }
}

export function timestampToDate(timestamp) {
  if (timestamp > 0) {
    let d = 1000
    if (timestamp > 100000000000) {
      d = 1
    }
    var date = new Date(timestamp * d) //时间戳为10位需*1000，时间戳为13位的话不需乘1000
    var Y = date.getFullYear() + '-'
    var M = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1) + '-'
    var D = (date.getDate() < 10 ? '0' + date.getDate() : date.getDate()) + ' '
    return Y + M + D
  } else {
    return '暂无'
  }
}

export function DateTotimestamp(date) {
  date = date.substring(0, 19)
  date = date.replace(/-/g, '/')
  var timestamp = new Date(date).getTime()
  return timestamp / 1000
}
